import {PopoverMenuItemType} from "../../gd-components/popover-menu/popover-menu/const"

export enum RenderDisplay {
    HIDDEN          = 0,
    VISIBLE         = 1,
    VISIBLE_GHOST   = 2,
    INVISIBLE_GHOST = 3,
}

export enum GoalType {

    PARENT_GOAL     = 1,
    CHECKBOX        = 2,    // done / not done
    COUNTER         = 3,    // 5 of 18
    CURRENCY        = 4,    // $100 of $200
    PERCENT         = 5,    // 85%
    TASK            = 6,
    PROJECT         = 7,
    EVENT           = 8,
}

export enum GoalEntityAddType {
    NEW                     = 'new',
    NEW_PROJECT_MILESTONE   = 'new-project-milestone',
    NEW_PROJECT_EVENT       = 'new-project-event',
    LINK_EXISTING           = 'link-existing'
}

export enum RateType {
    COUNTER         = GoalType.COUNTER,
    PROGRESS        = GoalType.PERCENT,
    CURRENCY        = GoalType.CURRENCY
}
export enum SubGoalType {
    CHECKBOX        = 0,
    TASK            = 1,
    PROJECT         = 2,
    MILESTONE       = 3,
    COUNTER         = 4,
    PROGRESS        = 5,
    CURRENCY        = 6,

}

export enum GoalExecutionType {
    ON_TRACK        = 0,
    AT_RISK         = 1,
    CLOSED          = 2
}

/*// SystemStatus
// 1 - not started !
// 2 - in progress ! - on track
// 3 - review       - .... -
// 4 - on hold      ! On Hold
// 5 - completed   ! Done (Archived)
// 6 - cancelled - ne nuzen
export enum GoalStatus {
    NOT_STARTED     = 1, // SystemStatus.NOT_STARTED
    ON_TRACK        = 2, //[SystemStatus.IN_PROGRESS],
    AT_RISK         = 3, // ???? 'At risk',
    CLOSED          = 5 //SystemStatus.COMPLETED
}*/

type GoalTypeOption = {
    hideInTypeSelector? : boolean,
    hideInNewSelector?  : boolean
} & Option

export const GoalTypeOptions : GoalTypeOption[] = [

    { label: 'ToDo',                value: GoalType.CHECKBOX,       icon: 'i5-checkbox'},
    { label: 'Progress',            value: GoalType.PERCENT,        icon: 'i5-percent'},
    { label: 'Counter',             value: GoalType.COUNTER,        icon: 'i5-numbers'},
    { label: 'Finance',    value: GoalType.CURRENCY,       icon: 'i5-money'},

    { type: PopoverMenuItemType.SEPARATOR, hideInTypeSelector: true},

    {
        type    : PopoverMenuItemType.POPOVER,
        icon    : 'i5-task',
        label   : 'Task',
        value   : GoalType.TASK,
        hideInTypeSelector: true,
        options : [
            {value: GoalEntityAddType.LINK_EXISTING,    icon: 'i5-search fs-12',    label: 'Add existing task'},
            {value: GoalEntityAddType.NEW,              icon: 'i5-plus fs-12',    label: 'Create new task'},
        ]
    },
    {
        type    : PopoverMenuItemType.POPOVER,
        icon    : 'i5-project',
        label   : 'Project',
        value   : GoalType.PROJECT,
        hideInTypeSelector: true,
        options : [
            {value: GoalEntityAddType.LINK_EXISTING,    icon: 'i5-search fs-12',    label: 'Add existing project'},
            {value: GoalEntityAddType.NEW,              icon: 'i5-plus fs-12',    label: 'Create new project'},
        ]
    },
    {
        type    : PopoverMenuItemType.POPOVER,
        icon    : 'i5-calendar',
        label   : 'Event',
        value   : GoalType.EVENT,
        hideInTypeSelector: true,
        options : [
            {value: GoalEntityAddType.LINK_EXISTING,            icon: 'i5-search fs-12',                            label: 'Add existing event'},
            {value: GoalEntityAddType.NEW_PROJECT_MILESTONE,    icon: 'i5-milestone',    label: 'New milestone'},
            {value: GoalEntityAddType.NEW_PROJECT_EVENT,        icon: 'i5-event-project-event',        label: 'New event'},
        ]
    },

    {
        label               : 'Parent',
        value               : GoalType.PARENT_GOAL,
        icon                : 'i5-workload-auto',
        hideInTypeSelector  : true,
        hideInNewSelector   : true
    },
]
